import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ allowedRoles, children }) => {
  const { user, loading } = useAuth();

  // ✅ Yükleme sırasında loading göster
  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        backgroundColor: '#030712',
        color: '#94a3b8'
      }}>
        Yükleniyor...
      </div>
    );
  }

  // ✅ Kullanıcı yoksa login'e yönlendir
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // ✅ Rol kontrolü
  if (Array.isArray(allowedRoles) && !allowedRoles.includes(user.rol)) {
    return (
      <div style={{ padding: 20, color: 'crimson', fontWeight: 'bold' }}>
        🚫 Bu sayfaya erişim yetkiniz yok.
      </div>
    );
  }

  // ✅ Erişim serbest
  return children;
};

export default ProtectedRoute;